import React from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { AssignReportTemplatesScope } from '../types/reportTemplateAssignment';

type Props = {
  show: boolean;
  departmentName: string;
  scopeLabel: string;
  saving?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const ClearAllReportTemplatesConfirmModal: React.FC<Props> = ({
  show,
  departmentName,
  scopeLabel,
  saving = false,
  onConfirm,
  onCancel,
}) => (
  <Modal
    show={show}
    onHide={onCancel}
    centered
    backdrop="static"
    keyboard={!saving}
    data-testid="clear-all-report-templates-confirm-modal"
  >
    <Modal.Header closeButton={!saving}>
      <Modal.Title>Save with no templates assigned?</Modal.Title>
    </Modal.Header>

    <Modal.Body>
      We noticed you&apos;ve unassigned all report templates for{' '}
      <strong>{departmentName}</strong> at this {scopeLabel}. Do you want to continue?
    </Modal.Body>

    <Modal.Footer>
      <Button variant="outline-secondary" onClick={onCancel} disabled={saving}>
        Cancel
      </Button>
      <Button variant="primary" onClick={onConfirm} disabled={saving} aria-busy={saving}>
        {saving ? (
          <>
            <Spinner size="sm" animation="border" className="me-2" aria-hidden="true" />
            Saving...
          </>
        ) : (
          'Yes, continue'
        )}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ClearAllReportTemplatesConfirmModal;
